import * as React from "react";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { Typography } from "@mui/material";

export default function CustomAlertBox() {
  return (
    <Alert severity="info" icon={false}>
      <Typography sx={{ textAlign: "justify" }}>
        Tap on the below "Cartube Installer" button below to start the
        installation process of Cartube Installer. Make sure that you{" "}
        <span style={{ fontWeight: "bold" }}>
          follow the steps using Safari Browser of your iPhone / iPad.
        </span>
      </Typography>
    </Alert>
  );
}
